import React, { useState } from 'react';

import { ChevronDown } from 'lucide-react';

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/shadcn/ui/collapsible';
import { cn } from '@/utils';

interface BuildDetailsGridProps {
  children: React.ReactNode;
  content?: React.ReactNode;
  collapsible?: boolean;
  className?: string;
  contentClassName?: string;
}

const BuildDetailsGrid: React.FC<BuildDetailsGridProps> = ({
  className,
  contentClassName,
  children,
  collapsible = false,
  content = null,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!collapsible) {
    return (
      <div className={cn('grid grid-cols-[18px_240px_1fr] gap-1 px-1 py-0.5', className)}>
        <div />
        {children}
      </div>
    );
  }

  return (
    <Collapsible
      className={cn('hover:bg-foreground rounded-xl transition-all duration-150', { 'bg-foreground py-2': isExpanded })}
      open={isExpanded}
      onOpenChange={setIsExpanded}
    >
      <CollapsibleTrigger asChild>
        <div className={cn('grid cursor-pointer grid-cols-[18px_240px_1fr] flex-nowrap gap-1 px-1 py-0.5', className)}>
          <div className="flex items-center justify-center">
            <ChevronDown
              className={cn('text-muted-foreground size-3.5 transition-transform duration-200', {
                'rotate-180': isExpanded,
              })}
            />
          </div>
          {children}
        </div>
      </CollapsibleTrigger>

      {isExpanded && <CollapsibleContent className={cn('px-1 py-0.5', contentClassName)}>{content}</CollapsibleContent>}
    </Collapsible>
  );
};

interface BuildDetailsGridLabelValuePairProps {
  label: string;
  value: string | React.ReactNode;
}

const BuildDetailsGridLabelValuePair: React.FC<BuildDetailsGridLabelValuePairProps> = ({ label, value }) => {
  return (
    <>
      <div>{label}</div>
      <div>{value}</div>
    </>
  );
};

export { BuildDetailsGridLabelValuePair };
export default BuildDetailsGrid;
